import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

/**
 * Wraps route children with a smooth, luxe page transition:
 * a soft pink veil sweeps + content fades/slides in.
 *
 * The veil is wrapped in a fixed overflow-hidden container so its
 * x-translation never pushes horizontal scroll width on mobile.
 */
export default function PageTransition({ children }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 18, filter: "blur(8px)" }}
        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        exit={{ opacity: 0, y: -10, filter: "blur(6px)" }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        style={{ willChange: "opacity, transform, filter" }}
      >
        {/* Containment box: pinned to viewport, hides any overflow caused
            by the veil's x-translation. */}
        <div
          aria-hidden
          className="fixed inset-0 z-[60] pointer-events-none overflow-hidden"
        >
          <motion.div
            initial={{ x: "-100%", opacity: 0.85 }}
            animate={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(110deg, transparent 0%, rgba(255,20,147,0.22) 35%, rgba(255,181,211,0.18) 50%, rgba(255,20,147,0.22) 65%, transparent 100%)",
              mixBlendMode: "screen",
            }}
          />
        </div>
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
